import { Pagination, Stack } from "@mui/material";
import { FC } from "react";
import { UIPaginationProps } from "./types";
import UIAutocomplete from "../ui-autocmplete";
import { SIZES } from "@/constants";

export const UIPagination: FC<UIPaginationProps> = ({
  sizes,
  ...restPaginationProps
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={sizes ? "space-between" : "center"}
      sx={{
        mt: 2,
      }}
    >
      <Pagination {...restPaginationProps} />
      {sizes && (
        <UIAutocomplete
          disableClearable
          value={String(sizes.currentRowsPerPage)}
          options={sizes?.rowsPerPageOptions || SIZES}
          onChange={(_event, value) =>
            sizes.onRowsPerPageChange?.(value || "10")
          }
        />
      )}
    </Stack>
  );
};
